import React from "react";

function contentLoader() {
    return (
        <React.Fragment>
            <section className="loaderDiv home-loadeDiv">
                <div className="_container">
                    <div className="_subcontainer">
                        <div className="loader-container">
                            <div className="loader-ContDiv tac">
                                <div className="loader-line shimmer wdt85"></div>
                                <div className="loader-line shimmer wdt75"></div>
                            </div>
                            <div className="loader-ContDiv tac">
                                <div className="loader-line shimmer wdt85"></div>
                                <div className="loader-line shimmer wdt85 mrgn-bwLoadr"></div>
                            </div>
                            <div className="loader-ContflexBox home-mrgn">
                                <div className="loader-ContBox loader-hmBx loader-tbBx">
                                    <div className="loader-line shimmer"></div>
                                </div>
                                <div className="loader-ContBox loader-hmBx loader-tbBx">
                                    <div className="loader-line shimmer"></div>
                                </div>
                                <div className="loader-ContBox loader-hmBx loader-tbBx">
                                    <div className="loader-line shimmer"></div>
                                </div>
                            </div>
                            <div className="loader-ContDiv margin-30">
                                <div className="loader-line shimmer hgt36"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="loaderDiv home-loadeDiv">
                <div className="_container">
                    <div className="_subcontainer">
                        <div className="loader-ContflexBox home-mrgn">
                            <div className="loader-ContBox loader-hmBx loader-strmTbs">
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContBox loader-hmBx loader-strmTbs">
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContBox loader-hmBx loader-strmTbs">
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContBox loader-hmBx loader-strmTbs">
                                <div className="loader-line shimmer"></div>
                            </div>
                        </div>
                        <div className="loader-container">
                            <div className="loader-ContDiv">
                                <div className="loader-line shimmer wdt36"></div>
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContDiv">
                                <div className="loader-line shimmer wdt36"></div>
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContDiv">
                                <div className="loader-line shimmer wdt36"></div>
                                <div className="loader-line shimmer"></div>
                            </div>
                            <div className="loader-ContDiv">
                                <div className="loader-line shimmer wdt36"></div>
                                <div className="loader-line shimmer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default contentLoader;
